import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('signal-payments', storeModule.createStoreModule('signal-payments'))
